import { defineAsyncComponent } from "vue";
const FilePickerVue = defineAsyncComponent(() => import("./FilePicker-Bp973DaS.mjs"));
export {
  FilePickerVue
};
//# sourceMappingURL=index-Cp_Wd5Qd.mjs.map
